import { MessageType } from '../../enums/message-type';
import { WebViewMessage } from './web-view-message';

export class RepositionCurrentWindowMessage extends WebViewMessage {
  private useLastKnownPosition: boolean;

  public constructor(useLastKnownPosition: boolean) {
    super(MessageType.RepositionCurrentWindowMessage);
    this.useLastKnownPosition = useLastKnownPosition;
  }
}
